var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthernet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.469,
    height: 10.341,
    viewBox: "0 0 8.469 10.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270",
    transform: "translate(-82.086 -489.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    d: "M17974.59-4983.02h7.453v6.292s.193.939-1.9.914-4.479,0-4.479,0a1.086,1.086,0,0,1-1.074-1.184C17974.623-4978.167,17974.59-4983.02,17974.59-4983.02Z",
    transform: "translate(-17892 5473)",
    fill: "none",
    stroke: "#7cd586",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M17974.59-4980.038h7.336",
    transform: "translate(-17892 5473)",
    fill: "none",
    stroke: "#7cd586",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3510",
    "data-name": "Path 3510",
    d: "M17978.258-4980.038v2.257",
    transform: "translate(-17892 5473)",
    fill: "none",
    stroke: "#7cd586",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3511",
    "data-name": "Path 3511",
    d: "M17978.318-4975.814v2.635",
    transform: "translate(-17892 5473)",
    fill: "none",
    stroke: "#7cd586",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernet);
export default __webpack_public_path__ + "static/media/ethernet.ca95bed50467fba0ea3b79ed5f9fa432.svg";
export { ForwardRef as ReactComponent };